import TeamList from './list'
import Title from './title'

const Teams = ({ teams }) => {
  const base = 'relative w-full flex flex-col md:flex-row justify-between gap-x-largeMobile lg:gap-x-largeDesktop mt-mediumDesktop lg:mt-largeDesktop'

  return (
    <div className={base}>
      <Title text={teams.title} />
      <TeamList teamList={teams.cards} />
    </div>
  )
}

export default Teams
